<div matDialogTitle class="driver-message__header">
  <h1 class="driver-message__header__title" i18n="@@S_SEND_MESSAGE">Send Message</h1>
  <button mat-icon-button matDialogClose class="driver-message__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="driver-message__content">
  <form class="driver-message__content__form" [formGroup]="messageForm" [ngClass]="{ submitted: isFormSubmitted }" novalidate>
    <mat-form-field floatLabel="always" class="driver-message__content__form__field">
      <mat-label class="form-label" i18n="@@S_TYPE">Type</mat-label>
      <mat-select
        formControlName="messageType"
        placeholder="Select an option"
        i18n-placeholder="@@S_SELECTANOPTION"
        (selectionChange)="onSelectionChanged($event)"
      >
        <mat-option [value]="EMessageType.Email" i18n="@@S_EMAIL">Email</mat-option>
        <mat-option [value]="EMessageType.Sms" i18n="@@S_SMS">SMS</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container formGroupName="emailMessage" *ngIf="selectedMessageType === EMessageType.Email">
      <mat-form-field floatLabel="always" class="driver-message__content__form__field">
        <mat-label class="form-label" i18n="@@S_ADDRESS">Address</mat-label>
        <input
          type="email"
          matInput
          placeholder="Enter your email address"
          i18n-placeholder="@@V_EMAIL_PLACEHOLDER"
          formControlName="email"
        />
        <mat-error *ngIf="messageForm?.get('emailMessage')?.getError('required')" i18n="@@V_EMAILADDRESS"
          >Please enter an email address</mat-error
        >
        <mat-error *ngIf="messageForm?.get('emailMessage')?.getError('email')" i18n="@@V_EMAIL"
          >Please enter a valid email address</mat-error
        >
      </mat-form-field>

      <mat-form-field floatLabel="always" class="driver-message__content__form__field driver-message__content__form__field__textarea">
        <mat-label class="form-label" i18n="@@S_MESSAGE">Message</mat-label>
        <textarea
          matInput
          placeholder="Enter your message"
          i18n-placeholder="@@S_MESSAGE_PLACEHOLDER"
          rows="5"
          formControlName="message"
        ></textarea>
        <mat-error *ngIf="messageForm?.get('emailMessage')?.invalid && isFormSubmitted" i18n="@@S_NO_MESSAGE_SPECIFIED"
          >No message specified</mat-error
        >
      </mat-form-field>

      <small class="form-text">
        <span i18n="@@S_SEND_MESSAGE_MAXCHARACTERS">Maximum characters: </span>
        <strong i18n="@@S_NO_LIMIT">No Limit</strong>
      </small>
    </ng-container>

    <ng-container *ngIf="selectedMessageType === EMessageType.Sms && phoneNumber">
      <ng-container *ngTemplateOutlet="smsTemplate"></ng-container>
    </ng-container>
  </form>
</div>

<div matDialogActions class="driver-message__actions">
  <button mat-button matDialogClose class="driver-message__actions__buttons__close btn-uppercase vzc-small" i18n="@@S_CLOSE">CLOSE</button>
  <button
    *ngIf="!isFormSubmitting"
    mat-flat-button
    color="accent"
    i18n="@@S_SEND"
    class="driver-message__actions__buttons__save btn-uppercase vzc-small"
    (click)="onSendMessageClick()"
    [disabled]="isFormSubmitDisabled"
  >
    SEND
  </button>
  <mat-spinner diameter="28" color="accent" *ngIf="isFormSubmitting"></mat-spinner>
</div>

<ng-template #smsTemplate>
  <fm-driver-sms-message
    *ngIf="selectedMessageType === EMessageType.Sms && phoneNumber"
    [smsMessage]="messageForm.get('smsMessage')"
    [smsOptInStatus]="smsOptInStatus$ | async"
    [isFormSubmitted]="isFormSubmitted"
    [phoneNumber]="phoneNumber"
    [smsInvitation]="smsInvitation$ | async"
    (sendSmsInvitation)="onSendSmsInvitation()"
  ></fm-driver-sms-message>
</ng-template>
